"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClosedSessionsTableData = void 0;
var react_1 = require("react");
var date_fns_1 = require("date-fns");
// import { ClosedSession } from '@l2p/profile-api'
var next_intl_1 = require("next-intl");
var useClosedSessionsTableData = function (data) {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'closedAt',
                    label: t('closedAt'),
                },
                {
                    field: 'ip',
                    label: t('ip'),
                },
                {
                    field: 'agent',
                    label: t('device'),
                },
            ],
            rows: [],
        };
        table.rows =
            (data === null || data === void 0 ? void 0 : data.map(function (item) {
                var ip = item.ip, agent = item.agent, closedAt = item.closedAt;
                return {
                    closedAt: (0, date_fns_1.format)(new Date(closedAt), 'HH:mm, dd-LL-yy'),
                    ip: ip,
                    agent: agent,
                };
            })) || [];
        return table;
    }, [data, t]);
};
exports.useClosedSessionsTableData = useClosedSessionsTableData;
